import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const LOGO_URL = "/media/img/capella-logo.png";

export default function AdminLoginPage() {
  const { login, error, user } = useAuth();
  const [email, setEmail] = useState("admin@capellacave.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user !== null && user !== false) {
      navigate("/admin", { replace: true });
    }
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/admin");
  };

  return (
    <div className="min-h-screen flex items-center justify-center font-admin bg-admin-bg p-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-10 border border-admin-border" data-testid="admin-login-form">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="Capella Cave" className="h-24 w-auto mb-4" data-testid="admin-login-logo" />
          <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-2">Yönetim Paneli</div>
          <h1 className="font-serif text-2xl text-cc-text">Capella Cave</h1>
        </div>

        <label className="block mb-5">
          <span className="text-[10px] tracking-overline uppercase text-cc-muted">E-posta</span>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="cc-input mt-1" />
        </label>
        <label className="block mb-7">
          <span className="text-[10px] tracking-overline uppercase text-cc-muted">Parola</span>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="cc-input mt-1" />
        </label>

        <button data-testid="login-submit" type="submit" disabled={loading} className="cc-btn w-full justify-center">
          {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
        </button>
        {error && <p className="mt-4 text-sm text-red-600" data-testid="login-error">{error}</p>}
      </form>
    </div>
  );
}
